import React from "react";

import CustomLoading from "./CustomLoading";

const InlineLoading: React.FC = () => <CustomLoading imageHeight="1rem" height="auto" inline />;

export default InlineLoading;
